import React, { useState } from "react";
import { useServerIp } from "../../hooks/useServerIp";

/**
 * Banka/sağlayıcıya bildirilecek sunucu çıkış IP'si.
 *
 * Tüm entegrasyonlarda aynı değer gösterilir: ödeme ve ERP istekleri aynı
 * sunucudan çıktığı için karşı taraf güvenlik duvarına bu tek adresi tanımlar.
 * Backend'de IP tanımlı değilse hiç çizilmez — boş bir kutu göstermek,
 * kullanıcının bankaya eksik bilgi vermesine yol açar.
 */
const labelStyle = {
    textTransform: "uppercase",
    letterSpacing: ".5px",
    fontSize: 12,
    fontWeight: 600,
    color: "#8b93a7",
};

export default function ServerIpNotice() {
    const ip = useServerIp();
    const [copied, setCopied] = useState(false);

    if (!ip) return null;

    const copy = () => {
        if (!navigator.clipboard?.writeText) return;
        navigator.clipboard.writeText(ip).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        });
    };

    return (
        <div className="d-flex align-items-center flex-wrap gap-2 mb-3" style={{ fontSize: 12.5 }}>
            {/* Alan etiketleriyle aynı tip (.field-label). Metin ZATEN büyük harf
                yazılı: CSS uppercase Türkçe "i"yi "I" yapıp "İSTENİRSE"yi bozuyor. */}
            <span style={labelStyle}>IP TANIMLAMASI İSTENİRSE</span>
            <code style={{ color: "#c2255c" }}>{ip}</code>
            <button
                type="button"
                onClick={copy}
                className="btn btn-sm p-0 border-0 bg-transparent d-inline-flex align-items-center gap-1"
                style={{ fontSize: 12.5, color: copied ? "#2f9e44" : "#0A316E" }}
                title="Kopyala"
            >
                <i className={`bx ${copied ? "bx-check" : "bx-copy"}`} />
                {copied && "Kopyalandı"}
            </button>
        </div>
    );
}
